"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnalyticsClient = exports.CommunityAnalyticsListener = exports.CommunityAnalyticsClientProvider = exports.AnalyticsWebClientContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _analyticsNext = require("@atlaskit/analytics-next");
var _analyticsWebClient = require("@atlassiansox/analytics-web-client");
var _identity = require("../atl-analytics/identity");
var _analyticsClient = require("./analytics-client");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * WARNING: Not yet ready for use, do not use - use the CommunityAnalyticsClient in analytics-client instead.
 *
 * This file contains the context and provider for the analytics client (@atlaskit/analytics-next pattern) - these React
 * components can be wrapped around the app to provide the analytics client to the rest of the application.
 */
var AnalyticsWebClientContext = exports.AnalyticsWebClientContext = /*#__PURE__*/(0, _react.createContext)({
  analyticsWebClientInstance: null
});

/**
 * This listener component listens for analytics events and sends them to the analytics client (analytics-next pattern).
 */
var CommunityAnalyticsListener = exports.CommunityAnalyticsListener = function CommunityAnalyticsListener(_ref) {
  var children = _ref.children;
  var analyticsClient = useAnalyticsClient();
  var onEvent = (0, _react.useCallback)(function (event) {
    if (!analyticsClient) {
      return;
    }

    // TODO: modify this?
    var processedEventPayload = _objectSpread(_objectSpread({
      actionSubject: 'component',
      eventType: 'ui',
      source: 'default'
    }, event.payload), {}, {
      attributes: _objectSpread({}, event.payload['attributes'] || {})
    });
    var ANALYTICS_TYPE = process.env['ANALYTICS_TYPE'] || 'console';
    if (ANALYTICS_TYPE === 'console') {
      // eslint-disable-next-line
      console.log({
        event: processedEventPayload
      });
      void analyticsClient.onEvent(null, processedEventPayload);
    } else {
      void analyticsClient.onEvent(null, processedEventPayload);
    }
  }, [analyticsClient]);
  return /*#__PURE__*/_react["default"].createElement(_analyticsNext.AnalyticsListener, {
    channel: '*',
    onEvent: onEvent
  }, children);
};
/**
 * This provider component initializes the analytics client and provides it to the rest of the application (analytics-next
 * pattern).
 * @param settings
 * @param environment
 * @param children
 * @constructor
 */
var CommunityAnalyticsClientProvider = exports.CommunityAnalyticsClientProvider = function CommunityAnalyticsClientProvider(_ref2) {
  var settings = _ref2.settings,
    environment = _ref2.environment,
    children = _ref2.children;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    analyticsWebClientInstance = _useState2[0],
    setAnalyticsWebClientInstance = _useState2[1];
  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line
      console.log('Initializing analytics client');
      _analyticsClient.CommunityAnalyticsClient.clientSettings = settings;
      _analyticsClient.CommunityAnalyticsClient.clientEnvironment = environment;
      var client = _analyticsClient.CommunityAnalyticsClient.init();
      var aaid = _identity.Identity.getAtlassianUserId();
      if (aaid) {
        client.setUserInfo(_analyticsWebClient.userType.ATLASSIAN_ACCOUNT, aaid);
      }
      setAnalyticsWebClientInstance(client);
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(AnalyticsWebClientContext.Provider, {
    value: {
      analyticsWebClientInstance: analyticsWebClientInstance
    }
  }, children);
};
var useAnalyticsClient = exports.useAnalyticsClient = function useAnalyticsClient() {
  var context = (0, _react.useContext)(AnalyticsWebClientContext);
  if (!context) {
    throw new Error('calls to useAnalyticsClient must be wrapped in <WacAnalyticsClientProvider>!');
  }
  return context.analyticsWebClientInstance;
};